module.exports = __webpack_public_path__ + "assets/7b07fb77293cd180fd77891a40f2098b.png";